import {
  IfpCompanyForm,
  IfpEmploymentType,
  IfpOccupation,
  IfpWorkingHours,
  SecLoanCarOwnershipType,
  SecLoanOtherIncomeType,
  TimeUntilEmployedAgainEstimation,
} from '@shared/sec-loans'
import { YesNo } from '@ui-common/types'
import { IntlShape } from 'react-intl'

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const getIfpApplicantInfoLocalizedEnums = (formatMessage: IntlShape['formatMessage']) => {
  const yesNoTexts: Record<YesNo, string> = {
    [YesNo.Yes]: formatMessage({ id: 'common-yes' }),
    [YesNo.No]: formatMessage({ id: 'common-no' }),
  }

  const occupationLabels: Record<IfpOccupation, string> = {
    [IfpOccupation.Employed]: formatMessage({ id: 'common-applications-occupation-employed' }),
    [IfpOccupation.Entrepreneur]: formatMessage({ id: 'common-applications-occupation-entrepreneur' }),
    [IfpOccupation.Furlough]: formatMessage({ id: 'ifp-loans-applicant-occupation-furlough' }),
    [IfpOccupation.LongtermSickLeave]: formatMessage({ id: 'ifp-loans-applicant-occupation-longterm-sick-leave' }),
    [IfpOccupation.Pensioner]: formatMessage({ id: 'ifp-loans-applicant-occupation-pensioner' }),
    [IfpOccupation.StudyLeave]: formatMessage({ id: 'ifp-loans-applicant-occupation-study-leave' }),
    [IfpOccupation.Unemployed]: formatMessage({
      id: 'common-applications-occupation-unemployed',
    }),
    [IfpOccupation.Student]: formatMessage({
      id: 'common-applications-occupation-student',
    }),
    [IfpOccupation.OnFamilyLeave]: formatMessage({ id: 'ifp-loans-applicant-occupation-on-family-leave' }),
    [IfpOccupation.Other]: formatMessage({ id: 'ifp-loans-applicant-occupation-other' }),
  }

  const employmentTypeLabels: Record<IfpEmploymentType, string> = {
    [IfpEmploymentType.Permanent]: formatMessage({ id: 'employment-info-employment-type-permanent' }),
    [IfpEmploymentType.TimeLimited]: formatMessage({ id: 'employment-info-employment-type-time-limited' }),
  }

  const workingHoursLabels: Record<IfpWorkingHours, string> = {
    [IfpWorkingHours.FullTime]: formatMessage({ id: 'sec-loans-employment-info-working-hours-form-option-full-time' }),
    [IfpWorkingHours.PartTime]: formatMessage({ id: 'sec-loans-employment-info-working-hours-form-option-part-time' }),
  }

  const companyLegalFormLabels: Record<IfpCompanyForm, string> = {
    [IfpCompanyForm.LimitedCompany]: formatMessage({ id: 'sec-loans-company-form-limited-company' }),
    [IfpCompanyForm.LimitedPartnership]: formatMessage({ id: 'sec-loans-company-form-limited-partnership' }),
    [IfpCompanyForm.OpenCompany]: formatMessage({ id: 'sec-loans-company-form-open-company' }),
    [IfpCompanyForm.TradeName]: formatMessage({ id: 'sec-loans-company-form-trade-name' }),
  }

  const timeUntilEmployedAgainEstimationLabels: Record<TimeUntilEmployedAgainEstimation, string> = {
    [TimeUntilEmployedAgainEstimation.OneToThreeMonths]: '1-3',
    [TimeUntilEmployedAgainEstimation.FourToSixMonths]: '4-6',
    [TimeUntilEmployedAgainEstimation.SevenToTwelveMonths]: '7-12',
    [TimeUntilEmployedAgainEstimation.OverAYear]: 'Yli vuosi',
  }

  const incomeInfoOtherIncomeLabelText: Record<SecLoanOtherIncomeType, string> = {
    [SecLoanOtherIncomeType.ChildAllowance]: formatMessage({
      id: 'sec-loans-income-info-other-income-form-option-child-allowance',
    }),
    [SecLoanOtherIncomeType.RentalIncome]: formatMessage({
      id: 'sec-loans-income-info-other-income-form-option-rental-income',
    }),
    [SecLoanOtherIncomeType.RegularExpenseReimbursements]: formatMessage({
      id: 'sec-loans-income-info-other-income-form-option-regular-expense-reimbursements',
    }),
    [SecLoanOtherIncomeType.DividendIncome]: formatMessage({
      id: 'sec-loans-income-info-other-income-form-option-dividend-income',
    }),
    [SecLoanOtherIncomeType.SideJob]: formatMessage({ id: 'sec-loans-income-info-other-income-form-option-side-job' }),
    [SecLoanOtherIncomeType.HousingAllowance]: formatMessage({
      id: 'sec-loans-income-info-other-income-form-option-housing-allowance',
    }),
    [SecLoanOtherIncomeType.Grant]: formatMessage({ id: 'sec-loans-income-info-other-income-form-option-grant' }),
    [SecLoanOtherIncomeType.ChildSupport]: formatMessage({
      id: 'sec-loans-income-info-other-income-form-option-child-support',
    }),
    [SecLoanOtherIncomeType.Pension]: formatMessage({ id: 'sec-loans-income-info-other-income-form-option-pension' }),
    [SecLoanOtherIncomeType.Other]: formatMessage({ id: 'common-other' }),
  }

  const expenseInfoCarOwnershipLabelTexts: Record<SecLoanCarOwnershipType, string> = {
    [SecLoanCarOwnershipType.OwnCar]: formatMessage({
      id: 'sec-loans-expenses-info-car-ownership-form-option-own-car',
    }),
    [SecLoanCarOwnershipType.Leasing]: formatMessage({
      id: 'sec-loans-expenses-info-car-ownership-form-option-leasing',
    }),

    [SecLoanCarOwnershipType.CompanyCarBenefitInKind]: formatMessage({
      id: 'sec-loans-expenses-info-car-ownership-form-option-benefit-in-kind',
    }),

    [SecLoanCarOwnershipType.CompanyCarFringeBenefit]: formatMessage({
      id: 'sec-loans-expenses-info-car-ownership-form-option-fringe-benefit',
    }),

    [SecLoanCarOwnershipType.OwnMultipleCars]: formatMessage({
      id: 'sec-loans-expenses-info-car-ownership-form-option-multiple-car',
    }),
  }

  return {
    yesNoTexts,
    occupationLabels,
    employmentTypeLabels,
    workingHoursLabels,
    companyLegalFormLabels,
    timeUntilEmployedAgainEstimationLabels,
    incomeInfoOtherIncomeLabelText,
    expenseInfoCarOwnershipLabelTexts,
  }
}
